import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const KeyboardOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function KeyboardOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path fillRule="evenodd" clipRule="evenodd" d="M19 3H5C2.79 3 1 4.79 1 7v10c0 2.21 1.79 4 4 4h14c2.21 0 4-1.79 4-4V7c0-2.21-1.79-4-4-4Zm0 2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14Z" />
          <path d="M7 11H5v2h2v-2ZM11 11H9v2h2v-2ZM15 11h-2v2h2v-2ZM19 11h-2v2h2v-2ZM19 7h-2v2h2V7ZM15 7h-2v2h2V7ZM11 7H9v2h2V7ZM7 7H5v2h2V7ZM16.5 15h-9v2h9v-2Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default KeyboardOutlined;